<template>
    <div class="content_box nopadding mobile_content">
        <div class="top fixed_top el_form">
            <div class="title">
                <span>扫地机设备故障统计</span>
            </div>
            <div class="time_box">
                <DatePicker :date="overviewTime" @dateSelect="dateSelect"></DatePicker>
            </div>
        </div>
        <div class="area">
            <div class="content reported">
                <div class="reported_box">
                    <div class="title subtitle title-1">
                        <span>故障码上报排行 top10</span>
                    </div>
                    <div class="failure_box data_area">
                        <div class="failure_item failure_item_tip" >
                            <div class="label">
                                <span class="serial serial_tip"></span>
                                <p class="code">故障码</p>
                                <p class="name ellipsis">故障信息</p>
                            </div>
                            <span class="number">上报次数</span>
                        </div>
                        <div class="failure_item" v-for="(item, i) in failureData" :key="item + i + 214234">
                            <div class="label">
                                <span class="serial" :class="'serial-' + (i+1)">{{i + 1}}</span>
                                <p class="code">{{item.code}}</p>
                                <el-tooltip popper-class="shadow" effect="light" :content="item.desc" placement="bottom-start">
                                    <p class="name ellipsis">{{item.desc}}</p>
                                </el-tooltip>
                            </div>
                            <div class="number">{{formatNumber(item.count)}}</div>
                        </div>
                        <div class="dataNone failure_none" v-if="!failureData || failureData.length == 0">暂无数据</div>
                    </div>
                </div>
            </div>
            <div class="content country">
                <div class="country_box">
                    <div class="title subtitle title-1">
                        <span>故障码上报国家/地区top10</span>
                    </div>
                    <div class="country_chart_box">
                        <div class="country_chart" ref="country_chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import resize  from "../../../minxins/resize"
export default({
    name: 'device-failure',
    mixins: [resize],
    data() {
        return {
            getFailureData: {
                start_time: '',
                end_time: ''
            },
            overviewTime: '',
            failureData: [],
            countryData: []
        }
    },
    watch: {
        'overviewTime' : function (nTime) {
            this.getFailureData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
            this.getFailureData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
            this.getDeviceFailure();
        },
    },
    created() {
        this.overviewTime = this.setDate(7);
    },
    methods: {
        dateSelect(date) {
            this.overviewTime = [...date];
        },
        getDeviceFailure() {
            this.api.getDeviceFailure(this.getFailureData).then(data => {
                this.failureData = data.data.data_list || [];
                this.countryData = data.data.countrys || [];
                this.initBarLine();
            })
        },
        initEcharts() {
            var countryChart = this.echarts.init(this.$refs.country_chart);
            countryChart.resize();
        },
        initBarLine() {
            let xData = [], countData = [], deviceData = [];
            this.countryData.forEach(item => {
                xData.push(item.name);
                countData.push(item.code_num);
                deviceData.push(item.count);
            })

			var countryChart = this.echarts.init(this.$refs.country_chart);
			countryChart.clear();
        	countryChart.setOption(this.setBarOption(xData,countData,deviceData));
		},
        setBarOption(key, value1, value2) {
			return {
				color: ['#507FF7', '#73EFE5'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross'
					}
				},
				legend: {
                    bottom: 0,
					itemWidth: 12,
					itemHeight: 12,
					itemGap: 20,
					textStyle: {
						color: '#999'
					},
					selectedMode: false,
					data: ['上报次数', '激活设备数']
				},
				grid: {
					left: '10',
					right: '10',
					top: '50',
					bottom: '50',
					containLabel: true
				},
				yAxis: [{
					type: 'value',
					name: '上报次数',
					alignTicks: true,
                    splitNumber: 4,
                    minInterval: 1,
					nameTextStyle: {
						lineHeight: '30'
					},
                    axisLabel: {
						color: '#868998'
					},
					splitLine: {
						lineStyle: {
                            type: 'dashed'
                        }
					},
				},{
					type: 'value',
					name: '激活设备数',
					alignTicks: true,
                    splitNumber: 4,
                    minInterval: 1,
					nameTextStyle: {
						lineHeight: '30'
					},
                    axisLabel: {
						color: '#868998'
					},
					splitLine: {
						lineStyle: {
                            type: 'dashed'
                        }
					},
				}],
				xAxis: {
					type: 'category',
					axisTick: {
						show: false
					},
                    axisLine: {
						show: false
					},
					axisLabel: {
						color: '#868998'
					},
					data: key
				},
				series: [{
					name: '上报次数',
					type: 'bar',
                    barMaxWidth: 30,
					data: value1
				},{
					name: '激活设备数',
					type: 'bar',
                    barMaxWidth: 30,
					yAxisIndex: 1,
					data: value2
				}]
			}
		},
    }
})
</script>
<style lang="less" scoped>
    .area{
        .flexLayout(space-between, flex-start);
        .title{
            .time_box{
                display: inline-block;
                margin-left: 20px;
                font-weight: 500;
            }
        }
        .reported{
            width: 35%;
            min-width: 420px;
            .failure_box{
                margin-top: 40px;
                .failure_item{
                    .flexLayout(space-between);
                    flex-wrap: nowrap;
                    font-size: 14px;
                    margin-bottom: 30px;
                    &.failure_item_tip{
                        font-size: 14px;
                        font-weight: 600;
                        background: #F7F8FA;
                        padding: 8px 0;
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                    .label{
                        .flexLayout(flex-start);
                        flex-wrap: nowrap;
                        width: calc(100% - 100px);
                        .serial{
                            @serialSize: 24px;
                            display: inline-block;
                            width: @serialSize;
                            height: @serialSize;
                            line-height: @serialSize;
                            border-radius: 50%;
                            text-align: center;
                            background: #F0F2F5;
                            color: #666;
                            font-weight: 500;
                            margin-right: 20px;
                            &.serial_tip{
                                background: none;
                            }
                            &.serial-1{
                                background: #507FF7;
                                color: #fff;
                            }
                            &.serial-2{
                                background: #507FF7;
                                color: #fff;
                                opacity: .8;
                            }
                            &.serial-3{
                                background: #507FF7;
                                color: #fff;
                                opacity: .6;
                            }
                        }
                        .code{
                            min-width: 50px;
                        }
                        .name{
                            color: #333;
                            margin-left: 20px;
                            max-width: 60%;
                            overflow: hidden;
                        }
                    }
                    .number{
                        width: 100px;
                        min-width: 100px;
                        text-align: center;
                    }
                }
                .dataNone{
                    background: #fff;
                    color: rgba(0,0,0,.3);
                    box-sizing: border-box;
                    font-size: 16px;
                    text-align: center;
                }
            }
        }
        .country{
            flex: 1;
            margin-left: 20px;
            .country_chart_box{
                margin-top: 40px;
                .country_chart{
                    width: 100%;
                    height: 400px;
                }
            }
            
        }
        @media (max-width: 768px) {
            padding: 0.1rem;
            border-radius: 12px;
            .title{
                .time_box {
                    margin-left: 0;
                    margin-top: 10px;
                    display: block;
                }
            }
            .content{
                height: auto;
            }
            .reported{
                width: 100%;
                min-width: 0;
                .failure_box{
                    width: 100%;
                    margin-top: 20px;
                    .failure_item {
                        font-size: 0.12rem;
                        margin-bottom: 20px;
                        .label {
                            width: calc(100% - 80px);
                            .serial {
                                width: 20px;
                                height: 20px;
                                line-height: 20px;
                            }
                        }
                        .number{
                            min-width: 80px;
                        }
                    }
                }
            }
            .country{
                margin-top: 20px;
                margin-left: 0;
            }
            
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/statistics/device/device-failure.vue